import { render, staticRenderFns } from "./SupplierProductForm.vue?vue&type=template&id=17cff550"
import script from "./SupplierProductForm.vue?vue&type=script&lang=js"
export * from "./SupplierProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports